<template>
  <div
    :class="{
      'loader-full': true,
      'loader-full--dark-blue': color === 'dark-blue',
    }"
    :style="styles"
  />
</template>
<script>
import { pxToRem } from '@lib/css';

export default {
  name: 'CircularSpinnerFull',

  props: {
    color: { type: String, default: 'white', validator: (color) => ['white', 'dark-blue'].includes(color) },
    size: { type: Number, default: 52 }, // Measured in px
  },

  computed: {
    styles() {
      // Convert to rem for scaling.
      const remSize = pxToRem(this.size);

      return {
        width: remSize,
        height: remSize,
        minHeight: remSize,
        minWidth: remSize,
        borderWidth: this.size >= 30 ? '3px' : '2px',
      };
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@styles/variables';

.loader-full {
  border-radius: 50%;
  border-top-color: rgba(255, 255, 255, 0.3);
  border-right-color: rgba(255, 255, 255, 0.3);
  border-bottom-color: rgba(255, 255, 255, 0.3);
  border-left-color: rgba(255, 255, 255, 0.6);
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  transform: translateZ(0);
  -webkit-animation: load8 1.1s infinite linear;
  animation: load8 1.1s infinite linear;
  border-style: solid;

  &--dark-blue {
    border-top-color: rgba($c-dark, 0.3);
    border-right-color: rgba($c-dark, 0.3);
    border-bottom-color: rgba($c-dark, 0.3);
    border-left-color: rgba($c-dark, 0.6);
  }
}
@-webkit-keyframes load8 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes load8 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
</style>
